import set from "lodash/set";

import { diDecorator } from "@/backend/di/diDecorator";

import { BaseService } from "../../../shared/application/base.service";
import { LimitService } from "../../organization/application/limit.service";
import { EPaymentPlan } from "../data/paymentPlans";
import { IPaymentPlan } from "../domain/PaymentPlan";
import { type PaymentPlanRepository } from "../domain/paymentPlan.repository";
import { SubscriptionService } from "./subscription.service";

//

export type UpdatabilityData =
  | {
      canUpdate: true;
      reason?: undefined;
      description?: undefined;
    }
  | {
      canUpdate: false;
      reason: string;
      description: string;
    };

//

export type PlanActions = "activate" | "cancel" | "stop";

//

@diDecorator.injectable()
export class PaymentPlanService extends BaseService<IPaymentPlan> {
  constructor(
    @diDecorator.inject("PaymentPlanRepository") public repository: PaymentPlanRepository,
    @diDecorator.inject("LimitService") public limitService: LimitService,
    @diDecorator.inject("SubscriptionService") public subscriptionService: SubscriptionService,
  ) {
    super(repository);
  }

  //

  public async getUpdatabilityData(
    organizationId: string,
  ): Promise<Record<EPaymentPlan, UpdatabilityData>> {
    const paymentPlans = await this.repository.find();
    const subscription = await this.subscriptionService.getByOrganizationId(organizationId);
    const limits = await this.limitService.getEveryLimit(organizationId);

    const result = {} as Record<EPaymentPlan, UpdatabilityData>;

    paymentPlans.map((plan) => {
      const isCurrentPlan = subscription.planId === plan.id;
      if (isCurrentPlan) {
        set(result, plan.id, {
          canUpdate: false,
          reason: "Текущий тариф",
          description: "Этот тариф уже активирован.",
        });
        return;
      }

      const passedLimits = this.limitService
        .calcRemainingForManyLimits(limits, plan.usageLimits)
        .every(({ remaining }) => remaining >= 0);

      if (!passedLimits) {
        set(result, plan.id, {
          canUpdate: false,
          reason: "Превышены лимиты",
          description: "Текущее использование превышает лимиты этого тарифа.",
        });
        return;
      }

      set(result, plan.id, {
        canUpdate: true,
      });
    });

    return result;
  }
}
